
























































import { Component, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobDto from '@/models/Jobs/JobDto';
import JobStatus from '@/models/Jobs/JobStatus';
import JobClosedReason from '@/models/Jobs/JobClosedReason';
import UpdateJobWorkerStatusContactInterestedRequest from '@/models/JobWorkers/UpdateJobWorkerStatusContactInterestedRequest';
import ListUtils from '@/lib/listUtils';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';

@Component({
    name: 'JobWorkerSetStatusContactInterested'
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  jobWorker: JobWorkerDto;
  @Prop({required: true})
  interested: boolean;
    
  request: UpdateJobWorkerStatusContactInterestedRequest = new UpdateJobWorkerStatusContactInterestedRequest();

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new UpdateJobWorkerStatusContactInterestedRequest();
      this.request.updatedAt = this.jobWorker.updatedAt;
      this.request.interested = this.interested;
      this.request.jobWorkerId = this.jobWorker.id; 
      if (this.interested) {
        //Default this to true if interested
        this.request.moveToInterviewOne = true;
      }
    } 
    this.$emit("closeMenu");
  }

  get notInterestedReasons() {
    return ListUtils.jobContactNotInterestedReasons();
  }

  get buttonText() {
    if (this.interested) {
      return "Contact Interested";
    }
    return "Contact Not Interested";
  }

    get dialogTitle() {
    if (this.interested) {
      return "Set Contact Interested";
    }
    return "Set Contact Not Interested";
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await JobDetailsModule.updateJobWorkerStatusContactInterested(this.request);
    this.dialog = false;
  }
}
